import React, { Component } from "react";
import "./AuthorWidget.css";
import moment from "moment";


export default class AuthorWidget extends Component {

    constructor(props){
      super(props);

      this.state ={
        authorName: this.props.blog.blogAuthor,
        title: this.props.blog.blogTitle,
        createdAt: this.props.blog.blogCreateTime
      }

    }

    render(){

      const profilePicElement = this.props.blog.authorProfilePic && this.props.blog.authorProfilePic.length > 0
                                      ? <img className="comments-author-image rotate90" src={""+this.props.blog.authorProfilePic} />
                                      :   <i className="fa fa-user comments-author-image"></i>;

      return(

          <div className="block-author">
              <div className="author-image ">
                  {profilePicElement}
              </div>
              <div className="author-info">
                  <span className="d-block heading-6 author-name strong-600 c-base-1">{this.state.title}</span>
                    <span className="heading-xs author-desc">Create {moment(this.state.createdAt).fromNow()}</span>
                  <br/> <span> By {this.state.authorName}</span> <br/>

              </div>
          </div>


      );
    }

}



// WEBPACK FOOTER //
// ./src/containers/AuthorWidget.js